import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { assets } from "../../lib/assets";
import { progressRepository } from "../../services/progress/progressRepository";
import { recordExploreEvent } from "../../services/explore/exploreActivity";
import { useAppStore } from "../../store/useAppStore";
import { BottomNav } from "./BottomNav";

export function AppShell() {
  const location = useLocation();
  const { activeChildId, hydrateProgress, stars, theme, toggleTheme } = useAppStore();
  const isHome = location.pathname === "/";
  const showBottomNav = ["/", "/explore", "/me"].includes(location.pathname);

  useEffect(() => {
    void progressRepository.load(activeChildId ?? "local-child").then((snapshot) => hydrateProgress(snapshot.stars, snapshot.completedTaskIds)).catch(() => undefined);
  }, [activeChildId, hydrateProgress]);

  useEffect(() => {
    void recordExploreEvent(activeChildId, "navigation.page_view", { itemId: location.pathname, kind: "navigation" });
  }, [activeChildId, location.pathname]);

  useEffect(() => {
    document.documentElement.style.colorScheme = theme === "night" ? "dark" : "light";
  }, [theme]);

  return (
    <main className={`app-shell theme-${theme}`}>
      <section className="landscape-stage">
        {isHome && (
          <header className="global-header">
            <img className="app-brand" src={assets.logo} alt="Lusky 鹿屿森空" />
            <div className="star-wallet"><img src={assets.rewardStar} alt="" /><span><small>我的星光</small><b>{stars}</b><em>颗</em></span></div>
            <button
              className="night-toggle"
              onClick={toggleTheme}
              aria-pressed={theme === "night"}
              aria-label={theme === "night" ? "切换到晨光日" : "切换到星光夜"}
            >
              {theme === "night" ? "☀" : "☾"} <span>{theme === "night" ? "晨光日" : "星光夜"}</span>
            </button>
            <a className="parent-link" href="/parent">家长空间 ›</a>
          </header>
        )}
        <Outlet />
        {showBottomNav && <BottomNav />}
      </section>
      <aside className="portrait-hint"><span>▭</span><p>竖屏也可以使用；横过来会看见更完整的鹿屿森空。</p></aside>
    </main>
  );
}
